import React from 'react';

import { Grid } from '@chakra-ui/react';

import {
  ActivitiesPerPartnerCard,
  AverageCostCard,
  MaterialCard,
  MaterialsPerRegionalCard,
  SeasonCostCard,
  StatusCard,
  WelcomeCard,
} from 'containers/Dashboard/Cards';

export default function GeneralInfo({ data }) {
  return (
    <Grid
      mt={8}
      templateColumns="repeat(6, 1fr)"
      gap={2}
      rowGap={4}>
      <WelcomeCard />
      <AverageCostCard data={data?.routes} />
      <MaterialCard
        color="primary.default"
        label="Materiais Coletados"
        data={data?.freights.collected}
      />
      <MaterialCard
        color="system.ongoing.default"
        label="Materiais em Trânsito"
        data={data?.freights.ongoing}
      />
      <MaterialCard
        color="system.success.default"
        label="Materiais Entregues"
        data={data?.freights.delivered}
      />
      <SeasonCostCard data={data?.averagePerPeriod} />
      <MaterialsPerRegionalCard
        data={data?.regionals.filter((regional) => regional.materials > 0)}
      />
      <StatusCard data={data} />
      <ActivitiesPerPartnerCard
        data={data?.partners.filter((partner) => partner.performedActivities > 0)}
      />
    </Grid>
  );
}
